import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.js';
import './styles/css/index.css';

// Global API for embedding the AI Agent
window.AiAgent = {
  init: function(options) {
    const { containerId, config } = options || {};
    
    if (!containerId) {
      console.error('AiAgent.init: containerId is required');
      return;
    }
    
    const container = document.getElementById(containerId);
    if (!container) {
      console.error(`AiAgent.init: Container with id "${containerId}" not found`);
      return;
    }
    
    // Store config globally so App can access it
    window.__AI_AGENT_CONFIG__ = config || {};
    
    // Create root and render
    const root = ReactDOM.createRoot(container);
    root.render(<App config={config} />);
    
    // Store cleanup function
    window.AiAgent._instances = window.AiAgent._instances || {};
    window.AiAgent._instances[containerId] = {
      root,
      destroy: function() {
        root.unmount();
        delete window.AiAgent._instances[containerId];
      }
    };
    
    console.log('AI Agent initialized in container:', containerId);
  },
  
  destroy: function(containerId) {
    if (window.AiAgent._instances && window.AiAgent._instances[containerId]) {
      window.AiAgent._instances[containerId].destroy();
    }
  }
};

// Auto-initialize if root element exists (for standalone mode)
if (document.getElementById('root')) {
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
}